import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=74e7a80c&scoped=true&"
import script from "./ChatBot.vue?vue&type=script&lang=js&"
export * from "./ChatBot.vue?vue&type=script&lang=js&"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=74e7a80c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e7a80c",
  null
  
)

export default component.exports